import React, { useState } from "react";
import styles from "./AdminProductJourney.module.css";
import HeadingComponent from "../../../../../../components/HeadingComponent/HeadingComponent";
import { TextComponent } from "../../../../../../components";
import TopTabComponent from "../../../../../../components/TopTabComponent/TopTabComponent";
import Mixing from "./Mixing/Mixing";
import { AiFillBehanceCircle } from "react-icons/ai";
import { ReactComponent as TabIcon } from "../../../../../../assets/images/tabIcon.svg";
import MakeUp from "./MakeUp/MakeUp";
import Proofing from "./Proofing/Proofing";
import Chilling from "./Chilling/Chilling";
import Oven from "./Oven/Oven";
import Packaging from "./Packaging/Packaging";
import Assembly from "./Assembly/Assembly";
import HeaderComponent from "../../../../../../components/HeaderComponent/HeaderComponent";

const AdminProductJourney = () => {
  const options = [
    { id: 1, name: "Mixing", Icon: <TabIcon width={16} height={16} /> },
    { id: 2, name: "Make Up", Icon: <TabIcon width={16} height={16} /> },
    { id: 3, name: "Proofing", Icon: <TabIcon width={16} height={16} /> },
    { id: 4, name: "Chilling", Icon: <TabIcon width={16} height={16} /> },
    { id: 5, name: "Oven", Icon: <TabIcon width={16} height={16} /> },
    { id: 6, name: "Packaging", Icon: <TabIcon width={16} height={16} /> },
    { id: 7, name: "Assembly", Icon: <TabIcon width={16} height={16} /> },
  ];
  const [focusedTab, setFocusedTab] = useState(options[0]);
  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <HeaderComponent
          showBackIcon={true}
          heading={"Product Journey: Bread Dough"}
          headingStyle={styles.Heading}
        />
      </div>
      <TopTabComponent
        options={options}
        focused={focusedTab}
        setFocused={setFocusedTab}
        TopTabListStyle={styles.TopTabListStyle1}
      />

      {focusedTab?.name === options[0]?.name && <Mixing />}
      {focusedTab?.name === options[1]?.name && <MakeUp />}
      {focusedTab?.name === options[2]?.name && <Proofing />}
      {focusedTab?.name === options[3]?.name && <Chilling />}
      {focusedTab?.name === options[4]?.name && <Oven />}
      {focusedTab?.name === options[5]?.name && <Packaging />}
      {focusedTab?.name === options[6]?.name && <Assembly />}
    </div>
  );
};

export default AdminProductJourney;
